<template>
  <div class="flsa-report-profile-preview-skeleton d-flex flex-column ga-8">
    <section class="flsa-report-preview-skel-metadata">
      <v-skeleton-loader
        type="text"
        width="72"
        height="24"
        class="mb-2 flsa-report-preview-skel-pill"
      />
      <v-skeleton-loader
        type="heading"
        width="85%"
        class="mb-2 flsa-report-preview-skel-title"
      />
      <div class="flsa-report-preview-skel-metadata-grid">
        <template
          v-for="i in metadataRowCount"
          :key="i"
        >
          <v-skeleton-loader
            type="text"
            width="110"
            class="flsa-report-preview-skel-line"
          />
          <v-skeleton-loader
            type="text"
            :width="metadataValueWidth(i)"
            class="flsa-report-preview-skel-line"
          />
        </template>
      </div>
    </section>

    <section class="flsa-report-preview-skel-alert">
      <v-skeleton-loader
        type="text"
        width="100%"
        height="120"
        class="flsa-report-preview-skel-alert-card"
      />
    </section>

    <section class="flsa-report-preview-skel-submissions">
      <v-skeleton-loader
        type="heading"
        width="75%"
        class="mb-1 flsa-report-preview-skel-section-title"
      />
      <div
        v-for="i in submissionRowCount"
        :key="i"
        class="flsa-report-preview-skel-row mb-4"
      >
        <v-skeleton-loader
          type="text"
          width="72"
          height="24"
          class="mb-2 flsa-report-preview-skel-pill"
        />
        <v-skeleton-loader
          type="text"
          width="45%"
          class="mb-1 flsa-report-preview-skel-line"
        />
        <v-skeleton-loader
          type="text"
          :width="submissionSecondLineWidth(i)"
          class="flsa-report-preview-skel-line"
        />
      </div>
    </section>
  </div>
</template>

<script setup>
const metadataRowCount = 3;
const submissionRowCount = 2;

const metadataValueWidth = (index) => {
  const widths = ['65%', '55%', '70%'];

  return widths[index - 1] ?? '60%';
};

const submissionSecondLineWidth = (index) => {
  const widths = ['88%', '76%'];

  return widths[index - 1] ?? '85%';
};
</script>

<style scoped lang="less">
:deep(.v-skeleton-loader .v-skeleton-loader__heading),
:deep(.v-skeleton-loader .v-skeleton-loader__text) {
  background: @bg-canvas;
}

.flsa-report-preview-skel-metadata-grid {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 10px;
  align-items: center;
}

.flsa-report-preview-skel-title :deep(.v-skeleton-loader__heading),
.flsa-report-preview-skel-section-title :deep(.v-skeleton-loader__heading) {
  height: 28px;
}

.flsa-report-preview-skel-line :deep(.v-skeleton-loader__text) {
  height: 16px;
  border-radius: 6px;
}

.flsa-report-preview-skel-pill :deep(.v-skeleton-loader__text) {
  height: 24px;
  border-radius: 24px;
}

.flsa-report-preview-skel-alert-card :deep(.v-skeleton-loader__text) {
  height: 120px;
  border-radius: 8px;
}
</style>
